import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const apiUrl = `${baseApiUrl}/api/criticalsituationfollowup`;

export async function getCriticalSituationFollowups(criticalSituationId) {
    return await httpRequest(fetchCriticalSituationFollowups.bind(this, criticalSituationId));
}
async function fetchCriticalSituationFollowups(criticalSituationId) {
    let config = getHttpHeaders();
    let url = `${apiUrl}?criticalSituationId=${criticalSituationId}`;
    return await axios.get(`${url}`, config);
}

export async function getCriticalSituationFollowupById(id) {
    return await httpRequest(fetchCriticalSituationFollowupById.bind(this, id));
}
async function fetchCriticalSituationFollowupById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${apiUrl}/${id}`, config);
}

export async function addCriticalSituationFollowup(data) {
    return await httpRequest(postCriticalSituationFollowup.bind(this, data));
}
async function postCriticalSituationFollowup(data) {
    let config = getHttpHeaders();
    return await axios.post(`${apiUrl}`, data, config);
}

export async function updateCriticalSituationFollowup(data) {
    return await httpRequest(putCriticalSituationFollowup.bind(this, data));
}
async function putCriticalSituationFollowup(data) {
    let config = getHttpHeaders();
    return await axios.put(`${apiUrl}`, data, config);
}
